export default __webpack_public_path__ + "static/media/afternoon-small-min.f2163729.jpg";